export enum ActionType {
  GET_DEPARTMENT_TEMPLATES = 'GET_DEPARTMENT_TEMPLATES',
  GET_DEPARTMENT_TEMPLATES_REJECTED = 'GET_DEPARTMENT_TEMPLATES_REJECTED',
  GET_DEPARTMENT_TEMPLATES_FULFILLED = 'GET_DEPARTMENT_TEMPLATES_FULFILLED',
  ADD_DEPARTMENT_TEMPLATE = 'ADD_DEPARTMENT_TEMPLATE',
  ADD_DEPARTMENT_TEMPLATE_REJECTED = 'ADD_DEPARTMENT_TEMPLATE_REJECTED',
  ADD_DEPARTMENT_TEMPLATE_FULFILLED = 'ADD_DEPARTMENT_TEMPLATE_FULFILLED',
  EDIT_DEPARTMENT_TEMPLATE = 'EDIT_DEPARTMENT_TEMPLATE',
  EDIT_DEPARTMENT_TEMPLATE_REJECTED = 'EDIT_DEPARTMENT_TEMPLATE_REJECTED',
  EDIT_DEPARTMENT_TEMPLATE_FULFILLED = 'EDIT_DEPARTMENT_TEMPLATE_FULFILLED',
  DELETE_DEPARTMENT_TEMPLATE = 'DELETE_DEPARTMENT_TEMPLATE',
  DELETE_DEPARTMENT_TEMPLATE_REJECTED = 'DELETE_DEPARTMENT_TEMPLATE_REJECTED',
  DELETE_DEPARTMENT_TEMPLATE_FULFILLED = 'DELETE_DEPARTMENT_TEMPLATE_FULFILLED',
  SET_ACTIVE_DEPARTMENT = 'SET_ACTIVE_DEPARTMENT',
}

export default ActionType;
